<template>
  <div style="z-index:999;">
    <div class="panel-header">
      <p class="panel-header-title">{{header}}</p>
      <div class="panel-content">
        <div class="notification-dropdown">
          <!-- dropdown icon -->
          <div v-html="require(`@/assets/imgs/terminal-page/notification.svg`)" class="icon"></div>
          <!-- dropdown content -->
          <div class="notification-dropdown-content-wrapper">
            <div class="space-holder"></div>
            <div
              class="notification-dropdown-content"
            >Welcome to Unibit! Please checkout our tutorial for more information.</div>
          </div>
        </div>
        <div class="tutorial-dropdown">
          <!-- dropdown icon -->
          <div
            v-html="require(`@/assets/imgs/terminal-page/help.svg`)"
            :class="['icon', {'promptTutorial': promptTutorial}]"
            @click="startIntroTutorial"
          ></div>
          <!-- dropdown content -->
          <div
            :class="['tutorial-dropdown-content-wrapper', {'showPromptTutorialDropdown': showPromptTutorialDropdown}]"
          >
            <div class="space-holder"></div>
            <div class="tutorial-dropdown-content">
              <TerminalBasicButton
                buttonText="Click to Show Tutorial"
                v-on:terminalBasicButtonClicked="startIntroTutorial"
              ></TerminalBasicButton>
            </div>
          </div>
        </div>

        <div class="user-dropdown">
          <!-- dropdown icon -->
          <p class="user-dropdown-username" @click="toAccount">{{username | shorten(28)}}</p>
          <DirectionArrow></DirectionArrow>
          <!-- dropdown content -->
          <div class="user-dropdown-content-wrapper">
            <div class="space-holder"></div>
            <div class="user-dropdown-content">
              <router-link :to="'/app'">{{getWindowLocalStorage('email')}}</router-link>

              <span id="planBox">Plan : {{plan}}</span>
              <div class="user-dropdown-content-upgrade">
                <router-link id="upgradeLink" :to="'/upgrade'">Upgrade Now - Go Premium</router-link>
              </div>

              <router-link :to="'/docs'">API Documentations</router-link>

              <p
                id="logout"
                @click="toLogout"
                data-toggle="collapse"
                data-target="#navbarSupportedContent"
              >Sign out</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import TerminalBasicButton from "@/components/base/terminal-basic-button";
import DirectionArrow from "@/components/utils/direction-arrow";
import { mapState, mapActions } from "vuex";

export default {
  props: {
    header: {
      type: String,
      default: "Terminal"
    }
  },

  components: {
    TerminalBasicButton,
    DirectionArrow
  },

  data() {
    return {
      promptTutorial: false,
      showPromptTutorialDropdown: false
    };
  },

  computed: {
    username() {
      const firstname =
        this.firstname.substr(0, 1).toUpperCase() + this.firstname.substr(1);
      const lastname =
        this.lastname.substr(0, 1).toUpperCase() + this.lastname.substr(1);
      return firstname + " " + lastname;
    },
    ...mapState({
      firstname: state => state.UserService.userFirstName,
      lastname: state => state.UserService.userLastName,
      plan: state => state.UserService.userPlan,
      showIntroTutorial: state => state.UserService.showIntroTutorial
    })
  },

  mounted() {
    // console.log(
    //   "terminal-header mounted() showIntroTutorial is: ",
    //   this.showIntroTutorial
    // );
    this.$nextTick(function() {
      // show tutorial if new user never tried tutorial
      if (this.showIntroTutorial === 0) {
        this.promptTutorial = true;
        this.showPromptTutorialDropdown = true;
      }
    });
  },

  methods: {
    toAccount() {
      this.$router.push("/app");
    },

    toLogout() {
      // console.log("1. Store dispatch: logout");
      this.$store.dispatch("logout");
      this.$store.commit("clearTableData");
      // console.log("2. Send Notify");
      this.$notify({
        group: "note",
        title: "UniBit Account",
        text: "Successfully logged out",
        type: "success"
      });
      // console.log("3. Login");
      this.$router.replace("/signin");
    },

    startIntroTutorial() {
      this.$store.dispatch("startIntroTutorial");
      this.promptTutorial = false;
      this.showPromptTutorialDropdown = false;
    }
  }
};
</script>


<style scoped>
* {
  font-family: Jura;
}

.panel-header {
  display: flex;
  justify-content: space-between;
  /* box-shadow: 0 14px 4px 0 #4a4a4a; */
  border: solid 0.1px #112027;
  height: 4rem;
  background-color: #112027;
  color: white;
}

.panel-header .icon {
  height: 2rem;
  stroke-width: 1px;
}

.panel-header-title {
  width: 169px;
  height: 27px;
  font-size: 1.5rem;
  font-weight: bold;
  letter-spacing: 1px;
  margin-top: 0.8rem;
  margin-left: 1.5rem;
}

.panel-header span:hover {
  cursor: pointer;
}

.panel-content {
  align-items: center;
  margin-right: 1.5rem;
}

.tutorial-dropdown:hover .tutorial-dropdown-content {
  display: block;
}

/* The container <div> - needed to position the dropdown content */
.notification-dropdown,
.tutorial-dropdown,
.user-dropdown {
  display: inline-block;
  height: 100%;
  font-size: 1rem;
  align-items: center;
  cursor: pointer;
  padding: 1rem;
}

.user-dropdown {
  font-size: 1.25rem;
}

.user-dropdown-username,
.user-dropdown-icon {
  display: inline-block;
  vertical-align: middle;
}

.promptTutorial {
  animation: shake 0.2s ease-in infinite;
}

@keyframes shake {
  from,
  to {
    transform: rotate(25deg);
  }
  50% {
    transform: rotate(-25deg);
  }
}

/* Dropdown Content (Hidden by Default) */
/* Introduction Tutorial dropdown */
.notification-dropdown-content-wrapper,
.tutorial-dropdown-content-wrapper,
.user-dropdown-content-wrapper {
  display: none;
  position: absolute;
  top: 4rem;
  z-index: 100;
  background-color: transparent;
  cursor: default;
}
.user-dropdown-content-wrapper-orange {
}

.notification-dropdown-content,
.tutorial-dropdown-content,
.user-dropdown-content {
  border-radius: 4px;
  background-color: #112027;
  box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
}

.space-holder {
  height: 0.5rem;
}

.notification-dropdown-content-wrapper {
  width: auto;
  max-width: 15rem;
  transform: translateX(-7.5rem);
}

.notification-dropdown-content {
  padding: 1rem;
}

.tutorial-dropdown-content-wrapper {
  width: auto;
  min-width: 5rem;
  transform: translateX(-7.05rem);
}

.tutorial-dropdown-content {
  width: 15rem;
  text-align: center;
  padding: 1rem;
}

.user-dropdown-content-wrapper {
  width: 19rem;
  min-width: 160px;
  left: auto;
  right: 0.5rem;
}

/* Links inside the dropdown */
.user-dropdown-content a {
  display: block;
  color: white;
  padding: 12px 22px;
  text-decoration: none;
}
.user-dropdown-content a:hover {
  cursor: pointer;
  background-color: #1b2e38;
  text-decoration: none;
}
.user-dropdown-content-upgrade a:hover {
  cursor: pointer;
  background-color: #1b2e38;
  text-decoration: none;
}
.user-dropdown-content p {
  display: block;
  color: white;
  font-size: 20px;
  font-weight: normal;
  padding: 12px 22px;
  cursor: pointer;
}
.user-dropdown-content p:hover {
  cursor: pointer;
  background-color: #1b2e38;
  text-decoration: none;
}
.user-dropdown-content hr {
  width: 85%;
  height: 1px;
  color: #1b2e38;
  background-color: #1b2e38;
  border: none;
  text-align: center;
  margin: 0 auto;
}

/* Show the dropdown menu on hover */
.notification-dropdown:hover .notification-dropdown-content-wrapper,
.tutorial-dropdown:hover .tutorial-dropdown-content-wrapper,
.user-dropdown:hover .user-dropdown-content-wrapper {
  display: block;
}

/* If never showed tutorial show tutorial dropdown */
.showPromptTutorialDropdown {
  display: block;
}

#planBox {
  margin: 14px 16px;
  padding: 5px 12px;
  font-weight: normal;
  font-size: 20px;
  letter-spacing: 0.47px;
  border-radius: 4px;
  border: solid 0.6px #ffffff;
}

#upgradeLink {
  color: #f5a623;
  /* border-bottom: solid 0.4px #3d3d3d; */
}
</style>



// WEBPACK FOOTER //
// src/components/fixed/terminal-header.vue